import { render, staticRenderFns } from "./PartnershipF.vue?vue&type=template&id=29503177&scoped=true"
import script from "./PartnershipF.vue?vue&type=script&lang=js"
export * from "./PartnershipF.vue?vue&type=script&lang=js"
import style0 from "./PartnershipF.vue?vue&type=style&index=0&id=29503177&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29503177",
  null
  
)

export default component.exports